import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import "./GradeSelector.scss";
import images from "../../../assets/images";

type Classroom = {
  cId: string;
  cOriginalName: string;
  cName: string;
};

interface ClassroomSelectorProps {
  allClasses: Classroom[];
  subjectClasses: Classroom[];
  setSelectedClassIds: Dispatch<SetStateAction<string[]>>;
  selectedClassIds: string[];
}

const ClassroomSelector: React.FC<ClassroomSelectorProps> = ({
  allClasses,
  subjectClasses,
  setSelectedClassIds,
  selectedClassIds,
}) => {
  const [enabledIds, setEnabledIds] = useState<string[]>([]);
  const { TickIcon } = images;

  useEffect(() => {
    // whenever subjectClasses changes, update which classes are enabled
    if (subjectClasses && subjectClasses.length > 0) {
      setEnabledIds(subjectClasses.map((cls) => cls.cId));
      setSelectedClassIds([]);
    } else {
      setEnabledIds([]); // disable all if no subject selected
    }
  }, [subjectClasses]);

  const toggleClass = (cId: string) => {
    if (!enabledIds.includes(cId)) {
      return; // prevent clicking disabled
    }
    setSelectedClassIds((prev) =>
      prev.includes(cId) ? prev.filter((id) => id !== cId) : [...prev, cId]
    );
  };

  return (
    <div className="grade-selector">
      <div className="grade-buttons">
        {
        [...allClasses]
        .sort((a, b) => {
          const aEnabled = enabledIds.includes(a.cId);
          const bEnabled = enabledIds.includes(b.cId);
          // Enabled should come first
          if (aEnabled === bEnabled) {
            return 0;
          }
          return aEnabled ? -1 : 1;
        })
        .map((cls) => {
          const isEnabled = enabledIds.includes(cls.cId);
          const isSelected = selectedClassIds.includes(cls.cId);

          return (
            <button
              key={cls.cId}
              className={`grade-button`}
              disabled={!isEnabled}
              onClick={() => toggleClass(cls.cId)}
            >
              <span className={`checkbox ${isSelected ? "checked" : ""}`}>
                {isSelected && (
                  <img
                    src={TickIcon}
                    alt="Selected"
                    className="checkmark-icon"
                  />
                )}
              </span>
              <span className="grade-label">{cls.cOriginalName}</span>
            </button>
          );
        })}
      </div>

      {/* Show selected IDs for debugging / final output
      <div className="selected-output">
        <strong>Selected Class IDs:</strong>{" "}
        {selectedClassIds.length > 0 ? selectedClassIds.join(", ") : "None"}
      </div> */}
    </div>
  );
};

export default ClassroomSelector;
